import React from 'react';
import { DestructiveActionDialog } from './DestructiveActionDialog';

interface JointPolicyDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: 'both' | 'client-only') => void;
  deleteMode: 'both' | 'client-only';
  onDeleteModeChange: (mode: 'both' | 'client-only') => void;
  clientName?: string;
  partnerName?: string;
}

export function JointPolicyDeleteDialog({
  open,
  onClose,
  onConfirm,
  deleteMode,
  onDeleteModeChange,
  clientName,
  partnerName,
}: JointPolicyDeleteDialogProps) {
  const primaryClientName = clientName || 'this client';
  const partnerClientName = partnerName || 'their partner';

  return (
    <DestructiveActionDialog
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm(deleteMode)}
      title="Delete Joint Policy"
      description={
        <div>
          <p className="mb-4">
            This is a joint policy that covers both {primaryClientName} and{' '}
            {partnerClientName}. Please choose how you&apos;d like to delete this policy:
          </p>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <input
                type="radio"
                id="delete-both"
                name="deleteMode"
                checked={deleteMode === 'both'}
                onChange={() => onDeleteModeChange('both')}
                className="text-primary-600"
              />
              <label
                htmlFor="delete-both"
                className="text-sm font-medium"
              >
                Delete for both {primaryClientName} and {partnerClientName}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                type="radio"
                id="delete-client-only"
                name="deleteMode"
                checked={deleteMode === 'client-only'}
                onChange={() => onDeleteModeChange('client-only')}
                className="text-primary-600"
              />
              <label
                htmlFor="delete-client-only"
                className="text-sm font-medium"
              >
                Delete for {primaryClientName} only
              </label>
            </div>
          </div>
        </div>
      }
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
    />
  );
}